import React, { useState } from "react";
import { loginUsuario, solicitarRegistro } from "../../api";
import { useUser } from "../context/AuthContext";
import logo from "../assets/lazerzonelogo.png";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Toast"; // ✅ Importa el Toast

const Auth = () => {
  const { verificarAutenticacion } = useUser();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [toast, setToast] = useState(null); // ✅ Estado del toast

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3500);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const email = e.target.loginEmail.value;
    const password = e.target.loginPassword.value;

    try {
      await loginUsuario({ email, password });
      await verificarAutenticacion();
      navigate("/admin");
    } catch (error) {
      console.error("Error en login: ", error.message);
      showToast("error", "Credenciales inválidas");
    }
  };

  const handleRequest = async (e) => {
    e.preventDefault();
    const name = e.target.requestName.value;
    const email = e.target.requestEmail.value;
    const password = e.target.requestPassword.value;

    try {
      await solicitarRegistro({ name, email, password });
      showToast("success", "Solicitud de registro enviada.");
      setActiveTab("login");
    } catch (error) {
      console.error("Error al solicitar registro: ", error.message);
      showToast("error", "Error al enviar solicitud");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 p-4">
      <div className="relative w-full max-w-md bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="p-6">
          <div className="flex justify-center mb-4">
            <img src={logo} alt="Logo" className="h-16" />
          </div>

          <div className="flex justify-center mb-6">
            <button
              onClick={() => setActiveTab("login")}
              className={`px-4 py-2 font-semibold rounded-tl rounded-bl mr-2 ${
                activeTab === "login"
                  ? "bg-yellow-400 text-gray-800"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              Admin Login
            </button>
            <button
              onClick={() => setActiveTab("request")}
              className={`px-4 py-2 font-semibold rounded-tr rounded-br ${
                activeTab === "request"
                  ? "bg-yellow-400 text-gray-800"
                  : "bg-gray-200 text-gray-600"
              }`}
            >
              Request Access
            </button>
          </div>

          {activeTab === "login" ? (
            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <input
                  type="email"
                  name="loginEmail"
                  placeholder="Email"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-6">
                <input
                  type="password"
                  name="loginPassword"
                  placeholder="Password"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded"
                />
              </div>
              <button
                type="submit"
                className="w-full py-2 bg-yellow-400 text-gray-800 font-semibold rounded hover:bg-yellow-500 transition"
              >
                Sign In
              </button>
            </form>
          ) : (
            <form onSubmit={handleRequest}>
              <div className="mb-4">
                <input
                  type="text"
                  name="requestName"
                  placeholder="Full Name"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <input
                  type="email"
                  name="requestEmail"
                  placeholder="Email"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-6">
                <input
                  type="password"
                  name="requestPassword"
                  placeholder="Password"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded"
                />
              </div>
              <button
                type="submit"
                className="w-full py-2 bg-yellow-400 text-gray-800 font-semibold rounded hover:bg-yellow-500 transition"
              >
                Send Request
              </button>
            </form>
          )}
        </div>
      </div>

      {toast && (
        <Toast
          type={toast.type}
          message={toast.message}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default Auth;
